module.exports = __webpack_public_path__ + "static/media/trauma.b6d7d0d1.svg";